var map = {
	"./2fa_qr.png": 9105,
	"./Aadhar.png": 4827,
	"./Background.png": 872,
	"./BeforeKyc.png": 38,
	"./Frame 14978.png": 3032,
	"./Globe.png": 7129,
	"./Id_doc_icon.png": 5142,
	"./Identification.png": 7982,
	"./Logo.png": 9217,
	"./No-data.webp": 3520,
	"./Rewards.png": 6254,
	"./Security (1).png": 6928,
	"./Security_icon.png": 8520,
	"./Vector (2).png": 9033,
	"./Vector.png": 8089,
	"./Visa.png": 6471,
	"./account.webp": 9269,
	"./airdrop-grid.png": 9776,
	"./airdrop-gridtwo.png": 9412,
	"./airdrop-nostatus.png": 3039,
	"./arr-five.webp": 4008,
	"./arr-four.webp": 7644,
	"./arr-three.webp": 2552,
	"./arr-two.webp": 7006,
	"./arr.webp": 505,
	"./arrow.png": 3021,
	"./bnb.png": 4788,
	"./btc.png": 9039,
	"./chat-person.webp": 326,
	"./coin_4x.webp": 1932,
	"./copie-card-chart.webp": 7518,
	"./copie-inimg.webp": 7649,
	"./cpy-blur.webp": 7778,
	"./currency/currency_4x.webp": 3542,
	"./currency_4x.webp": 4126,
	"./delete_icon.png": 7221,
	"./deposit-imp.png": 181,
	"./down-fiat.png": 1635,
	"./down_arrow.png": 1766,
	"./edit_icon.png": 5178,
	"./eth.png": 6811,
	"./eur.webp": 9390,
	"./facial_icon.png": 990,
	"./footer_logo.png": 5143,
	"./forex-trade.webp": 5243,
	"./gif/giffive.gif": 9768,
	"./gif/giffour.gif": 7828,
	"./gif/gifone.gif": 9956,
	"./gif/gifsix.gif": 3152,
	"./gif/gifthree.gif": 6648,
	"./gif/giftwo.gif": 3122,
	"./gif/keep-trading-gif-bg.gif": 1684,
	"./gif/keep-trading-gif.gif": 8108,
	"./gif/mobile-gif.gif": 7453,
	"./gif/mobile.gif": 9912,
	"./gift_icon.png": 2476,
	"./gplay.webp": 4261,
	"./greenarrow.png": 9000,
	"./high_line.png": 7419,
	"./icons/2fa.webp": 5928,
	"./icons/Identification.webp": 3099,
	"./icons/algo-bar-active-graph.webp": 8286,
	"./icons/algo-bar-graph.webp": 3331,
	"./icons/algo-notes-active-graph.webp": 766,
	"./icons/algo-notes-graph.webp": 4211,
	"./icons/anti_phishing_icon.webp": 1090,
	"./icons/asset-crossmargin-icon.png": 7264,
	"./icons/asset-funding-icon.png": 1179,
	"./icons/asset-spot-icon.png": 3368,
	"./icons/asset-stake-icon.png": 4844,
	"./icons/bell.webp": 576,
	"./icons/coindeck.webp": 1377,
	"./icons/coingeckgo.webp": 7328,
	"./icons/coinmarket.webp": 2412,
	"./icons/copy_trade.webp": 934,
	"./icons/dash_id_icon.webp": 7121,
	"./icons/dashboard_icon.webp": 1385,
	"./icons/deposit_icon.png": 5251,
	"./icons/deposit_icon.webp": 4147,
	"./icons/download.webp": 3685,
	"./icons/easy-option.webp": 2007,
	"./icons/email-pop-close.png": 92,
	"./icons/email-pop.webp": 169,
	"./icons/email_icon.webp": 4365,
	"./icons/fast_transaction_icon.webp": 2272,
	"./icons/fiu.png": 2453,
	"./icons/fiu.webp": 7007,
	"./icons/future.webp": 9626,
	"./icons/gmail.webp": 17,
	"./icons/handover-money.png": 6259,
	"./icons/history_icon.webp": 5021,
	"./icons/instagram.webp": 7795,
	"./icons/linkedin.webp": 383,
	"./icons/login_icon.webp": 7786,
	"./icons/login_password_icon.webp": 1273,
	"./icons/logout.webp": 763,
	"./icons/low_fees.webp": 475,
	"./icons/margin-trade.webp": 8536,
	"./icons/my_reward_icon.webp": 5425,
	"./icons/nav-fiat.webp": 6129,
	"./icons/nav-internal-trans.webp": 3707,
	"./icons/nav-invite.webp": 5792,
	"./icons/notverify.webp": 8075,
	"./icons/optional-trade.webp": 7942,
	"./icons/p2p-orders.webp": 8909,
	"./icons/p2p-payment.webp": 3170,
	"./icons/p2p-plus.png": 930,
	"./icons/profile_dark.webp": 1555,
	"./icons/proof.webp": 4749,
	"./icons/reddit.webp": 7457,
	"./icons/robust_icon.webp": 4676,
	"./icons/security.webp": 3395,
	"./icons/so.webp": 6599,
	"./icons/speaker.webp": 2734,
	"./icons/spot-trade.webp": 1274,
	"./icons/support.webp": 3560,
	"./icons/telegram.webp": 1666,
	"./icons/verified.webp": 3299,
	"./icons/vol_bg.png": 4870,
	"./icons/withdraw-warn.png": 2226,
	"./icons/withdraw-warn.webp": 8154,
	"./icons/withdraw_icon.webp": 3373,
	"./icons/yellow-arrow.webp": 6377,
	"./icons/youtube.webp": 8234,
	"./icudtl.dat.png": 1286,
	"./impact.webp": 2407,
	"./int-transfer-swap.png": 7525,
	"./invite-frame.webp": 4212,
	"./ipay.webp": 5637,
	"./j.png": 75,
	"./kyc-unavail.png": 8832,
	"./leaderboard-success.png": 6885,
	"./line.webp": 6732,
	"./login-mobile.webp": 1900,
	"./login_icon.png": 7402,
	"./low_line.png": 1831,
	"./maintanence.webp": 69,
	"./mid_line.png": 4307,
	"./mobile-gradient.png": 6561,
	"./mobile_popup_icon.png": 8309,
	"./no-copytrade-data.webp": 6500,
	"./not-add-pay.png": 1598,
	"./not-found.webp": 9666,
	"./otc-algo-chart.webp": 4023,
	"./passport_icon.png": 8528,
	"./person_icon.png": 3623,
	"./phone_icon.png": 8668,
	"./phonepe.png": 8740,
	"./process-bg.png": 3645,
	"./profile_icon.png": 3801,
	"./qr.png": 9585,
	"./redarrow.png": 5608,
	"./refer_earn_banner.webp": 1086,
	"./refer_earn_bg.webp": 6823,
	"./referral_asset.webp": 6064,
	"./reg-gift.webp": 8977,
	"./register-bg.webp": 845,
	"./security.png": 4494,
	"./select-down.png": 5563,
	"./soon.webp": 8821,
	"./spot.png": 360,
	"./stake-bitcoin.webp": 231,
	"./stake-hero-ab.webp": 5513,
	"./staking-bg.png": 1821,
	"./stars.png": 7370,
	"./start-arrow.png": 2318,
	"./stopwatch.png": 5127,
	"./straightLine.png": 7136,
	"./success.webp": 5421,
	"./swap_icon.png": 9833,
	"./swipercard-five.png": 665,
	"./swipercard-four.png": 9841,
	"./swipercard-one.png": 4921,
	"./swipercard-six.png": 3329,
	"./swipercard-three.png": 2017,
	"./swipercard-two.png": 6359,
	"./take_photo_icon.png": 9614,
	"./trade-bnb.webp": 5327,
	"./trade-btc.webp": 8942,
	"./trade-doge.webp": 5110,
	"./trade-eth.webp": 7386,
	"./trade-sol.webp": 4259,
	"./trade-xrp.webp": 2059,
	"./tron.png": 6037,
	"./upload_file_icon.png": 2108,
	"./usdt.png": 2276,
	"./withdraw-depo-unavail.png": 4054,
	"./withdraw-unavailable.png": 6575,
	"./withdraw_icon.png": 1636,
	"./xrp.png": 2504,
	"./yel-gradient.png": 5263,
	"./yel-rad-bg.png": 9448,
	"./yellow-arrow.png": 6568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;